import type { ReactNode } from 'react';
import {
  Building2,
  Calculator,
  Code2,
  FileSearch,
  FolderArchive,
  GitCompareArrows,
  History,
  KeyRound,
  ListChecks,
} from 'lucide-react';
import { CabecalhoSecao } from './CabecalhoSecao';
import base from './publico.module.css';
import css from './Secoes.module.css';

export function Escritorios() {
  return (
    <section id="escritorios" className={base.secao}>
      <div className={base.conteudo}>
        <CabecalhoSecao
          sobretitulo="Para escritórios fiscais e contábeis"
          titulo="O arquivo que a apuração precisa"
        >
          O DANFE mostra a nota; o XML é a nota. Base de cálculo, alíquota, CST,
          CFOP e valor por item só existem no arquivo — e é dele que saem o
          crédito apurado, a conferência e a resposta a uma fiscalização.
        </CabecalhoSecao>

        <div className={css.recursos}>
          <Recurso
            icone={<KeyRound />}
            titulo="Sem certificado digital"
            texto="Nada de A1 instalado, senha de certificado ou procuração eletrônica no e-CAC. Você traz a chave — do SPED ou da sua lista — e nós buscamos o arquivo."
          />
          <Recurso
            icone={<Calculator />}
            titulo="Apuração e conferência de créditos"
            texto="ICMS, IPI, PIS e COFINS item a item, com CST e base de cálculo direto da fonte. Sem redigitar, sem depender do que o cliente lembrou de mandar."
          />
          <Recurso
            icone={<GitCompareArrows />}
            titulo="Cruzamento com o SPED"
            texto="Extraímos as chaves do próprio arquivo que você já entrega ao Fisco. O que estiver escriturado e sem XML aparece na hora — inclusive as notas que ninguém percebeu que faltavam."
          />
          <Recurso
            icone={<FolderArchive />}
            titulo="Guarda pelo prazo legal"
            texto="A legislação exige o arquivo digital pelo prazo decadencial — cinco anos. Baixe o histórico de uma vez e guarde onde quiser: o ZIP é seu."
          />
          <Recurso
            icone={<History />}
            titulo="Cliente novo, histórico inteiro"
            texto="Assumiu a contabilidade no meio do ano? Suba os SPEDs anteriores e reconstitua o período completo em um envio."
          />
          <Recurso
            icone={<FileSearch />}
            titulo="Auditoria e due diligence"
            texto="Reconstitua meses ou anos fechados para revisão fiscal, recuperação de crédito ou levantamento pré-aquisição."
          />
          <Recurso
            icone={<Building2 />}
            titulo="Volume de escritório"
            texto="Dezenas de empresas por mês, centenas de milhares de notas. O preço cai conforme o volume, e a fila aguenta o fechamento inteiro rodando junto."
          />
          <Recurso
            icone={<ListChecks />}
            titulo="Contagem honesta"
            texto="Baixados, não encontradas na fonte e falhas transitórias aparecem separados. Não escondemos o que deu errado, e não cobramos por ele."
          />
          <Recurso
            icone={<Code2 />}
            titulo="API própria"
            texto="Consulta por chave, lotes e webhooks para o seu sistema — ou para revender a seus clientes. A documentação está em API, no topo da página."
          />
        </div>
      </div>
    </section>
  );
}

function Recurso({
  icone,
  titulo,
  texto,
}: {
  icone: ReactNode;
  titulo: string;
  texto: string;
}) {
  return (
    <div className={css.recurso}>
      <span className={css.iconeQuadro} aria-hidden="true">
        {icone}
      </span>
      <h3 className={css.tituloRecurso}>{titulo}</h3>
      <p className={css.paragrafo}>{texto}</p>
    </div>
  );
}
